(function () {
  var section = document.querySelector('[data-skn-our-why]');
  if (!section) return;

  var panels = section.querySelectorAll('[data-skn-panel]');
  var chapters = section.querySelectorAll('[data-skn-formula-chapter]');
  var dimTargets = section.querySelectorAll('[data-skn-panel="0"], .skn-our-why__persona');
  var portrait = section.querySelector('.skn-our-why__image');
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mobileMq = window.matchMedia('(max-width: 989px)');
  var sampleCanvas = null;
  var sampleCtx = null;
  var sampleReady = false;
  var sampleTainted = false;

  var WHY_SCROLL_VH = 5;
  var FORMULA_SCROLL_VH = 4.5;

  var REVEAL_END = 0.22;
  var SCALE_START = 0.26;
  var SCALE_END = 0.56;
  var IMAGE_Y_TRAVEL = 0.42;

  var tracks = [
    { start: SCALE_START, end: SCALE_END },
    { start: 0.5, end: 0.94 }
  ];
  var FADE_START = 0.92;
  var FADE_END = 1;
  var FADE_LERP = 1.35;

  var FORMULA_TITLE_END = 0.16;
  var formulaChapterTracks = [
    { start: 0.18, end: 0.38 },
    { start: 0.4, end: 0.6 },
    { start: 0.62, end: 0.82 }
  ];

  var fadeShown = 0;
  var fadeLastTs = 0;
  var fadeLoopActive = false;

  function isMobile() {
    return mobileMq.matches;
  }

  function smoothstep(t) {
    return t * t * (3 - 2 * t);
  }

  function getVh() {
    return window.innerHeight;
  }

  function getScrollInto() {
    return Math.max(0, -section.getBoundingClientRect().top);
  }

  function whyProgress() {
    var span = WHY_SCROLL_VH * getVh();
    if (span <= 0) return 0;
    return Math.min(1, getScrollInto() / span);
  }

  function formulaProgress() {
    var into = getScrollInto();
    var start = WHY_SCROLL_VH * getVh();
    var span = FORMULA_SCROLL_VH * getVh();
    if (into <= start || span <= 0) return 0;
    return Math.min(1, (into - start) / span);
  }

  function phaseProgress(progress, start, end) {
    if (progress <= start) return 0;
    if (progress >= end) return 1;
    return smoothstep((progress - start) / (end - start));
  }

  function panelTranslateY(progress, track, panel) {
    var vh = getVh();
    var height = panel.offsetHeight || 0;
    var travel = vh + height + 48;

    if (progress <= track.start) return vh;
    if (progress >= track.end) return -height - 48;

    var t = (progress - track.start) / (track.end - track.start);
    return vh - t * travel;
  }

  function revealProgress(progress) {
    if (progress >= REVEAL_END) return 1;
    if (progress <= 0) return 0;
    return smoothstep(progress / REVEAL_END);
  }

  function scaleProgress(progress) {
    if (progress <= SCALE_START) return 0;
    if (progress >= SCALE_END) return 1;
    return smoothstep((progress - SCALE_START) / (SCALE_END - SCALE_START));
  }

  function fadeTargetProgress(progress) {
    if (progress <= FADE_START) return 0;
    if (progress >= FADE_END) return 1;
    var t = (progress - FADE_START) / (FADE_END - FADE_START);
    return t * t * t * (t * (t * 6 - 15) + 10);
  }

  function setChapterOffsets() {
    var vw = window.innerWidth;
    chapters.forEach(function (chapter) {
      chapter.style.setProperty('--skn-formula-ch-offset', vw + 'px');
    });
  }

  function prepareSample() {
    if (sampleReady || sampleTainted || !portrait || !portrait.naturalWidth) return;

    try {
      sampleCanvas = document.createElement('canvas');
      var w = 140;
      var h = Math.max(1, Math.round((portrait.naturalHeight / portrait.naturalWidth) * w));
      sampleCanvas.width = w;
      sampleCanvas.height = h;
      sampleCtx = sampleCanvas.getContext('2d', { willReadFrequently: true });
      sampleCtx.drawImage(portrait, 0, 0, w, h);
      sampleCtx.getImageData(0, 0, 1, 1);
      sampleReady = true;
    } catch (err) {
      sampleTainted = true;
      sampleReady = false;
    }
  }

  function visibleImageRect() {
    if (!portrait) return null;
    var r = portrait.getBoundingClientRect();
    if (r.width < 8 || r.height < 8) return null;

    var reveal = parseFloat(section.style.getPropertyValue('--skn-why-reveal')) || 0;
    var exit = parseFloat(section.style.getPropertyValue('--skn-why-exit')) || 0;
    var leftInset = Math.max((1 - reveal) * r.width, exit * 0.5 * r.width);
    var side = exit * 0.5;

    return {
      left: r.left + leftInset,
      top: r.top + side * r.height,
      right: r.right - side * r.width,
      bottom: r.bottom - side * r.height,
      width: r.width,
      height: r.height,
      rawLeft: r.left,
      rawTop: r.top
    };
  }

  function overlapRect(a, b) {
    var left = Math.max(a.left, b.left);
    var top = Math.max(a.top, b.top);
    var right = Math.min(a.right, b.right);
    var bottom = Math.min(a.bottom, b.bottom);
    var width = right - left;
    var height = bottom - top;
    if (width <= 2 || height <= 2) return null;
    return { left: left, top: top, right: right, bottom: bottom, width: width, height: height };
  }

  function sampleDarkness(overlap, image) {
    if (!sampleReady || !sampleCtx) return 0.82;

    var sx = Math.floor(((overlap.left - image.rawLeft) / image.width) * sampleCanvas.width);
    var sy = Math.floor(((overlap.top - image.rawTop) / image.height) * sampleCanvas.height);
    var sw = Math.max(1, Math.floor((overlap.width / image.width) * sampleCanvas.width));
    var sh = Math.max(1, Math.floor((overlap.height / image.height) * sampleCanvas.height));

    sx = Math.max(0, Math.min(sampleCanvas.width - 1, sx));
    sy = Math.max(0, Math.min(sampleCanvas.height - 1, sy));
    sw = Math.min(sampleCanvas.width - sx, sw);
    sh = Math.min(sampleCanvas.height - sy, sh);

    var data = sampleCtx.getImageData(sx, sy, sw, sh).data;
    var sum = 0;
    var count = 0;
    for (var i = 0; i < data.length; i += 16) {
      sum += 0.2126 * data[i] + 0.7152 * data[i + 1] + 0.0722 * data[i + 2];
      count += 1;
    }
    if (!count) return 0;
    var lum = sum / count / 255;
    return Math.max(0, Math.min(1, (0.64 - lum) / 0.46));
  }

  function updateTextDim() {
    if (isMobile() || reduced) {
      dimTargets.forEach(function (el) {
        el.style.setProperty('--skn-why-dim', '0');
      });
      return;
    }

    prepareSample();
    var image = visibleImageRect();

    dimTargets.forEach(function (el) {
      if (!image || image.right <= image.left || image.bottom <= image.top) {
        el.style.setProperty('--skn-why-dim', '0');
        return;
      }

      var box = el.getBoundingClientRect();
      var hit = overlapRect(box, image);
      if (!hit) {
        el.style.setProperty('--skn-why-dim', '0');
        return;
      }

      var coverage = (hit.width * hit.height) / Math.max(1, box.width * box.height);
      var dim = Math.max(0, Math.min(1, (coverage - 0.04) / 0.22));
      el.style.setProperty('--skn-why-dim', dim.toFixed(3));
    });
  }

  function applyWhy(progress, fade) {
    var reveal = revealProgress(progress);
    var scaleT = scaleProgress(progress);
    var baseScale = 0.58 + 0.42 * scaleT;
    var imageY = getVh() * IMAGE_Y_TRAVEL * (1 - reveal);

    section.style.setProperty('--skn-why-image-scale', baseScale.toFixed(3));
    section.style.setProperty('--skn-why-reveal', reveal.toFixed(3));
    section.style.setProperty('--skn-why-image-y', imageY.toFixed(2) + 'px');
    /* Hold the portrait at the size it has reached. The dark screen fades in
       over it; the portrait does not shrink away. */
    section.style.setProperty('--skn-why-exit', '0');
    section.style.setProperty('--skn-why-bg-fade', fade.toFixed(4));

    panels.forEach(function (panel, index) {
      var track = tracks[index];
      if (!track) return;
      var y = panelTranslateY(progress, track, panel);
      panel.style.transform = 'translateY(' + y.toFixed(2) + 'px)';
      panel.style.opacity = '1';
    });

    updateTextDim();
  }

  function applyFormula(fProgress, fade) {
    var showFormula = fade >= 0.96 || fProgress > 0;
    section.style.setProperty('--skn-why-formula-visible', showFormula ? '1' : '0');

    if (!showFormula) {
      section.style.setProperty('--skn-formula-title', '0');
      chapters.forEach(function (chapter) {
        chapter.style.setProperty('--skn-formula-ch', '0');
      });
      return;
    }

    var titleP = phaseProgress(fProgress, 0, FORMULA_TITLE_END);
    section.style.setProperty('--skn-formula-title', titleP.toFixed(3));

    chapters.forEach(function (chapter, index) {
      var track = formulaChapterTracks[index];
      if (!track) return;
      var chP = phaseProgress(fProgress, track.start, track.end);
      chapter.style.setProperty('--skn-formula-ch', chP.toFixed(3));
    });
  }

  function apply(fade) {
    var wProgress = whyProgress();
    var fProgress = formulaProgress();
    applyWhy(wProgress, fade);
    applyFormula(fProgress, fade);
  }

  function resetMobile() {
    fadeShown = 0;
    fadeLastTs = 0;
    fadeLoopActive = false;
    section.style.removeProperty('--skn-why-image-scale');
    section.style.removeProperty('--skn-why-image-y');
    section.style.removeProperty('--skn-why-exit');
    section.style.removeProperty('--skn-why-bg-fade');
    section.style.removeProperty('--skn-why-formula-visible');
    section.style.setProperty('--skn-why-reveal', '1');
    section.style.setProperty('--skn-why-bg-fade', '1');
    section.style.setProperty('--skn-why-formula-visible', '1');
    section.style.setProperty('--skn-formula-title', '1');
    panels.forEach(function (panel) {
      panel.style.transform = '';
      panel.style.opacity = '';
    });
    dimTargets.forEach(function (el) {
      el.style.setProperty('--skn-why-dim', '0');
    });
    chapters.forEach(function (chapter) {
      chapter.style.setProperty('--skn-formula-ch', '1');
    });
  }

  function tick(ts) {
    if (isMobile() || reduced) {
      resetMobile();
      fadeLoopActive = false;
      return;
    }

    if (!fadeLastTs) fadeLastTs = ts;
    var dt = Math.min((ts - fadeLastTs) / 1000, 0.05);
    fadeLastTs = ts;

    var wProgress = whyProgress();
    var target = fadeTargetProgress(wProgress);
    var alpha = 1 - Math.exp(-FADE_LERP * dt);
    fadeShown += (target - fadeShown) * alpha;

    if (Math.abs(target - fadeShown) < 0.0004) {
      fadeShown = target;
    }

    setChapterOffsets();
    apply(fadeShown);

    if (Math.abs(target - fadeShown) > 0.0004) {
      requestAnimationFrame(tick);
    } else {
      fadeLoopActive = false;
    }
  }

  function onScroll() {
    setChapterOffsets();
    if (fadeLoopActive) {
      apply(fadeShown);
      return;
    }
    fadeLastTs = 0;
    fadeLoopActive = true;
    requestAnimationFrame(tick);
  }

  function scheduleTick() {
    onScroll();
  }

  if (portrait) {
    if (portrait.complete) prepareSample();
    else portrait.addEventListener('load', prepareSample);
  }

  setChapterOffsets();
  scheduleTick();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () {
    setChapterOffsets();
    scheduleTick();
  });
  document.addEventListener('shopify:section:load', scheduleTick);
})();
